module.exports = __webpack_public_path__ + "img/M007-17_jrb-01.15c9fdba.jpg";